/**
 * this file contains all the endpoints
 *
 * Created by Tom on 18/06/18
 */

// REACT_APP_WEBSITE_URL env variable need to be passed before JS compiled
if (!process.env.REACT_APP_WEBSITE_URL)
    throw new Error('The REACT_APP_WEBSITE_URL environment variable is required but was not specified.')

const websiteUrl = process.env.REACT_APP_WEBSITE_URL
const rootAPIUrl = websiteUrl + '/api'

const config = {
    "endpoints" : {

        // Main website url
        "websiteURL": websiteUrl,

        // Website urls
        "websiteSignInURL": websiteUrl + '/sign-in/',
        "websiteSignOutURL": websiteUrl + '/sign-out/',
        "websiteAboutURL": websiteUrl + '/about/',
        "websiteFAQsURL": websiteUrl + '/faqs/',
        "websiteHowItWorksURL": websiteUrl + '/how-it-works/',
        "websiteTermsURL": websiteUrl + '/terms-conditions/',
        "websitePrivacyPolicyURL": websiteUrl + '/privacy-policy/',

        "tradingExternalURL": 'https://www.macquarie.com.au/FIM/trading/',

        "rootAPIUrl": rootAPIUrl,

        // fetch url for the list of transactions
        "transactionFetchURL" : rootAPIUrl +"/accounting/transaction_details/{startDate}/{endDate}/",

        // fetch url for the list of Investment
        "investmentFetchURL" : rootAPIUrl +"/accounting/asset_position/{todayDate}/",

        // fetch url for Investment download
        "investmentDownloadURL" : rootAPIUrl +"/accounting/asset_position/download/",

        // fetch url for the list of Portfolio value
        "portfolioFetchURL" : rootAPIUrl +"/accounting/fund_value/{startDate}/{endDate}/",

        // fetch url for Portfolio download
        "portfolioDownloadURL" : rootAPIUrl +"/accounting/investment_summary/download/",

        // fetch member profile data
        "profileFetchURL" :  rootAPIUrl + "/profile/",

        // update member profile data
        "profileUpdateURL" :  rootAPIUrl + "/profile/update/",

        // feth fund detail data
        "fundFetchURL" :  rootAPIUrl + "/accounting/fund_detail_report/",

        // fetch notifications data
        "notificationFetchURL": rootAPIUrl + "/notifications/",

        // dimiss/complete a notification
        "notificationDismissURL": rootAPIUrl + "/notifications/{id}/dismiss/",

        // fetch doc sign link
        "docSignLinkFetchURL" :  rootAPIUrl + "/document/sign-docs-url/",

        // fetch document status
        "doccumentStatusURL" :  rootAPIUrl + "/document/status/",

        // fetch docs data
        "documentsFetchURL" :  rootAPIUrl + "/document/",

        // download doc link
        "documentDownloadURL" :  rootAPIUrl + "/document/{id}/download/",

        // verify auth
        "authVerifyURL": rootAPIUrl + "/auth/verify/",

        //Billing application
        "billingFetchURL": rootAPIUrl +"/payments/",

        //Billing download
        "billingDownloadURL": rootAPIUrl +"/payments/download/{id}/",

        // fetch news data
        "newsFetchURL": rootAPIUrl + "/latest-news/",
    }
}

export default config



// WEBPACK FOOTER //
// ./src/config.js